<template>
	<div class="xueyuan container">
		<!-- <h1>人员管理</h1> -->

		  <el-select v-model="username" v-loading="loading2" size = 'small' placeholder="请选择公司" @change="handleChange">
		    <el-option
		      v-for="item in admin"
		      :key="item.id"
		      :label="item.dw"
		      :value="item.name">
		    </el-option>
		  </el-select>

		  <el-input placeholder="请输入关键字快速检索" prefix-icon="el-icon-search" v-model="input" class="input-with-select" clearable @change = "doFilter" size="small">
		    <el-select v-model="select" slot="prepend" placeholder="请选择">
		      <el-option label="检索全部" value="1"></el-option>
		      <el-option label="姓名" value="2"></el-option>
		      <el-option label="证件号" value="3"></el-option>
		      <el-option label="关联车辆" value="4"></el-option>
		    </el-select>
		  </el-input>


		<div style="clear:both;"></div>
		  <el-table
		  	v-loading="loading"
		  	element-loading-text="加载中"
		  	stripe
		  	:data="xueyuan.slice((currentPage-1)*pagesize,currentPage*pagesize)"
		    style="width: 100%"
		    :row-class-name="tableRowClassName">
		    <el-table-column
		      type="index"
		      width="50"
		      align="center">
		    </el-table-column>
		    <el-table-column
		      prop="name"
		      label="姓名"
		      align="center">
		    </el-table-column>
		    <el-table-column
		      prop="zjh"
		      label="证件号"
		      width="200"
		      align="center">
		    </el-table-column>
		    <el-table-column
		      prop="clname"
		      label="关联车辆"
		      width="200"
		      align="center">
		    </el-table-column>
		    <el-table-column
 		    :filters="[{ text: '驾驶员', value: '驾驶员' }, { text: '押运员', value: '押运员' }, { text: '装卸员', value: '装卸员' }]"
 		    :filter-method="filterLx"
      		filter-placement="bottom-end"
		      prop="lx"
		      label="类型"
		      align="center">
		    </el-table-column>

 		    <el-table-column
 		    :filters="[{ text: '已完成', value: '已完成' }, { text: '未完成', value: '0分钟' }]"
 		    :filter-method="filterSl"
      		filter-placement="bottom-end"
		      prop="studylog"
		      label="本月学习"
		      align="center">
		      <template slot-scope="scope">
		        <el-tag
		          :type="scope.row.studylog === '已完成' ? 'success' : (scope.row.studylog === '0分钟' ? 'danger' : 'warning')"
		          disable-transitions>{{scope.row.studylog}}</el-tag>
		      </template>
		    </el-table-column>

 		    <el-table-column
 		    :filters="[{ text: '正常', value: '正常' }, { text: '停用', value: '停用' }]"
 		    :filter-method="filterZt"
      		filter-placement="bottom-end"
		      prop="zt"
		      label="状态"
		      width="110"
		      align="center">
		      <template slot-scope="scope">
		        <el-tag
		          :type="scope.row.zt === '正常' ? 'success' : (scope.row.zt === '停用' ? 'danger' : 'info')"
		          disable-transitions>{{scope.row.zt}}</el-tag>
		      </template>
		    </el-table-column>

		    <el-table-column label="操作" width="140" align="center">
		      <template slot-scope="scope">
		      	<el-tooltip class="item" effect="dark" content="编辑" placement="left">
		      		<el-button type="primary" size="mini" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)"></i></el-button>
		      	</el-tooltip>
	      		<el-button type="danger" size="mini" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"></el-button>
		      </template>
		    </el-table-column>
		  </el-table>

		    <el-pagination
		    v-show="pageshow"
		      background
		      @size-change="handleSizeChange"
		      @current-change="handleCurrentChange"
		      :current-page="currentPage"
		      :page-sizes="[10, 20, 50, 100]"
		      :page-size="pagesize"
		      layout="total, sizes, prev, pager, next, jumper"
		      :total="total">
		    </el-pagination>

		<el-dialog title="人员详情" :visible.sync="dialogFormVisible">
			<el-form :model="form" :rules="rules" ref="ruleForm" size="small" status-icon>
				<el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
					<el-input v-model="form.name" auto-complete="off"></el-input>
				</el-form-item>

				<el-form-item label="证件号" :label-width="formLabelWidth" prop="zjh">
					<el-input v-model="form.zjh" auto-complete="off"></el-input>
				</el-form-item>

			<el-form-item label="关联车辆" :label-width="formLabelWidth" prop="glcl">
				<el-select v-model="form.glcl" multiple filterable placeholder="请选择">
					<el-option
						v-for="item in cheliang"
						:key="item.id"
						:label="item.cph"
						:value="'cheliang'+item.id">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="类型" :label-width="formLabelWidth" prop="cpys">
			    <el-radio-group v-model="form.lx" size="medium">
			      <el-radio-button label="驾驶员"></el-radio-button>
			      <el-radio-button label="押运员"></el-radio-button>
			      <el-radio-button label="装卸员"></el-radio-button>
			    </el-radio-group>
			</el-form-item>
			<el-form-item label="状态" :label-width="formLabelWidth" prop="cpys">
			    <el-radio-group v-model="form.zt" size="medium">
			      <el-radio-button label="正常"></el-radio-button>
			      <el-radio-button label="停用"></el-radio-button>
			    </el-radio-group>
			</el-form-item>

		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="resetForm('ruleForm');">取 消</el-button>
			<el-button type="primary" @click="submitForm('ruleForm');">确 定</el-button>
		</div>
	</el-dialog>
	</div>
</template>

<script>
	import Addx from './Addx'

	export default {
		computed:{
			admin(){
				return this.$store.state.admin;
			},
			cheliang(){
				return this.$store.state.cheliang;
			},
			xueyuan(){
				return (this.dw.length > 0) ? this.dw : this.$store.state.xueyuan;
			},
			dw(){
				return this.$store.getters.getXueyuan(this.input,this.select);
			},
			total(){
				return this.xueyuan.length;
			},
			pageshow(){
				return this.total > 0;
			}
		},
		data(){
			return{
				username:'',
				input: '',
				select: "1",
				pagesize:10,
                currentPage:1,//默认开始页面
				loading: false,
				loading2: true,
		        dialogFormVisible: false,
				form: {
					id:0,
					name: '',
					zjh: '',
					glcl:[],
					clname:[],
					lx:'驾驶员',
					zt:'正常',
					password:'',
					studylog:[]
				},
		        formLabelWidth: '120px',
				rules:{
					cph: [
						{ required: true, message: '请填写车牌号', trigger: 'blur' },
						{ min: 7, max: 7, message: '请检查车牌格式', trigger: 'blur' }
					],
					ssdw: [
						{ required: true, message: '请选择所属单位', trigger: 'blur' }
					],
				}
			}
		},
		components:{
			Addx
		},
		methods:{
			handleChange(val) {
				this.loading = true;
				this.getCheliang();
			},
			filterSl(value, row) {
				return row.studylog === value;
		    },
			filterZt(value, row) {
				return row.zt === value;
		    },
			filterLx(value, row) {
				return row.lx === value;
		    },
			doFilter(val) {
				if (this.dw.length == 0) this.$message({showClose: true,message: '没有找到包含【'+val+'】的内容',type: 'warning'});
			},
			handleSizeChange(val) {
				this.pagesize = val;
			},
			handleCurrentChange(val) {
				this.currentPage = val;
			},
			submitForm(formName) {
			this.$refs[formName].validate((valid) => {
			  if (valid) {
			  	this.$message({showClose: true,message: '正在提交'});
			  	this.dialogFormVisible = false;
			  	this.editXueyuan();
			  } else {
			    this.$message({showClose: true,message: '请检查填写内容',type: 'warning'});
			    return false;
			  }
			});
			},
			editXueyuan(){
				this.loading = true;
				var params = new URLSearchParams();
				params.append('token', 'gqgU1wqtfzcZRAniU');
		        params.append('admin', this.username);
		        params.append('my', this.$store.getters.token);
				params.append('name', this.form.name);
				params.append('zjh', this.form.zjh);
				params.append('glcl', this.form.glcl);
				params.append('lx', this.form.lx);
				params.append('zt', this.form.zt);
				params.append('password', this.form.password);
				params.append('id', this.form.id);
				this.$ajax.post("/apis/xueyuan.php",params).then((ret) => {
			    	console.log(ret)
			    	this.loading = false;
			    	if (ret.data == true) {
			    		// this.$store.dispatch('editXueyuan',this.form);
			    		this.$store.commit('editXueyuan',this.form);
					    this.$message({showClose: true,message: '已修改',type: 'success'});
					    this.resetForm('ruleForm');
			    	}else this.$notify.error({title: '错误',message: ret.data});
				}).catch(err=>{
				    this.$notify.error({title: '错误',message: '网络异常'});
				    this.loading = false;
				});
			},
			resetForm(formName) {
				this.dialogFormVisible = false;
				this.$refs[formName].resetFields();
			},
			handleEdit(i,r){
				this.dialogFormVisible = true;
				this.form.name = r.name;
				this.form.zjh = r.zjh;
				this.form.glcl = r.glcl;
				this.form.lx = r.lx;
				this.form.zt = r.zt;
				this.form.id = r.id;
				this.form.password = r.password;
			},
			handleDelete(i,r){
		        this.$confirm('此操作将永久删除该项, 是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		        }).then(() => {
		        	this.loading = true;
		        	this.$message({showClose: true,message: '删除中……'});
					var params = new URLSearchParams();
					params.append('token', 'sqgU1wqtfzcZRAniU');
			        params.append('admin', this.username);
			        params.append('my', this.$store.getters.token);
					params.append('id', r.id);
					this.$ajax.post("/apis/xueyuan.php",params).then((ret) => {
	                	this.loading = false;
	                	if (ret.data == true) {
	                		this.$store.commit('delXueyuan', r);
	                		this.$message({showClose: true,type: 'success',message: '删除成功!'});
	                	}else this.$notify.error({title: '错误',message: ret.data});
					}).catch(err=>{
					    this.$notify.error({title: '错误',message: '网络异常'});
					    this.loading = false;
					});
		        }).catch(() => {
		          this.$message({showClose: true,type: 'info',message: '已取消'});          
		        });
			},
			tableRowClassName({row, rowIndex}) {
				return '';
			},
			  getCheliang(){
			    var params = new URLSearchParams();
			    params.append('token', 'cqgU1wqtfzcZRAniU');
			    params.append('admin', this.username);
			    params.append('my', this.$store.getters.token);
			    this.$ajax.post("/apis/cheliang.php",params).then((ret) => {
			      if (ret.data != "token错误" && ret.data != "数据库连接失败")
			        this.$store.commit('setCheliang', ret.data.sort(this.compare));
			        this.getXueyuan();
			    });
			  },
			getXueyuan(){
				var params = new URLSearchParams();
				params.append('token', 'cqgU1wqtfzcZRAniU');
		        params.append('admin', this.username);
		        params.append('my', this.$store.getters.token);
				this.$ajax.post("/apis/xueyuan.php",params).then((ret) => {
                	this.loading = false;
                	if (ret.data != "token错误" && ret.data != "数据库连接失败") {
                		this.$store.commit('setXueyuan', ret.data.sort(this.compare));
                		//this.total = this.xueyuan.length;
                	}else this.$notify.error({title: '错误',message: ret.data});
				}).catch(err=>{
					console.log(err);
				    this.$notify.error({title: '错误',message: '网络异常'});
				    this.loading = false;
				});
			},
			getAdmin(){
				var params = new URLSearchParams();
				params.append('token', 'cqgU1wqtfzcZRAniU');
		        params.append('admin', this.$store.getters.name);
		        params.append('my', this.$store.getters.token);
				this.$ajax.post("/apis/admin.php",params).then((ret) => {
                	// console.log(ret.data);
                	this.loading2 = false;
                	if (ret.data != "token错误" && ret.data != "数据库连接失败") {
                		this.$store.commit('setAdmin', ret.data.sort(this.compare));
                	}else this.$notify.error({title: '错误',message: ret.data});
				}).catch(err=>{
					console.log(err);
				    this.$notify.error({title: '错误',message: '网络异常'});
				    this.loading = false;
				});
			},
			compare(v1, v2){
				if (Number(v1.id) < Number(v2.id)){
					return 1;
				}else if (Number(v1.id) > Number(v2.id)){
					return -1;
				}else{
					return 0;
				}
			}
		},
		created(){
			if (this.admin.length == 0) this.getAdmin();
			else this.loading2 = false;
		}
	}
</script>

<style scoped>
	.el-select{
	width:300px;
	}
	.el-pagination{
	    display: flex;
	    justify-content:center;
	    align-items:center;
	}
  .el-input-group__prepend .el-select {
    width: 130px;
  }
  .input-with-select {
    width: 500px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
    float: left;
  }
</style>


// WEBPACK FOOTER //
// src/components/ZXueyuan.vue